import CashMemoPage from '../../pages/CashMemoPage';

export default CashMemoPage;